module.exports = __webpack_public_path__ + "static/media/school-records.812e4d7b.svg";